var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hero", style: _vm.heroStyles },
    [
      _vm._t("top-content"),
      _c(
        _vm.slides.length > 1 ? "VueSlickCarousel" : "div",
        _vm._b(
          { tag: "div", staticClass: "hero__carousel", attrs: { dots: "" } },
          "div",
          _vm.sliderSettings,
          false
        ),
        _vm._l(_vm.slides, function(slide, index) {
          return _c(
            "a",
            {
              key: "hero_" + _vm._uid + "_slide" + index,
              staticClass: "hero__slide",
              class: { "hero__slide--content-below": slide.content_below },
              attrs: { href: slide.link }
            },
            [
              _c("img", {
                staticClass: "hero__image",
                attrs: {
                  src: ["desktop", "hd"].includes(_vm.$mq)
                    ? slide.background_image
                    : slide.mobile_background_image,
                  alt: slide.background_image_alt
                }
              })
            ]
          )
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }